// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names */
// Mapper
// Types
import type { AncillariesInput, Ancillaries } from "../../../scenes/BookingAncillary/consts/types"
import mapperUsCoverMoreInsurance from "./mapperUsCoverMoreInsurance"
import mapperAxaInsuranceAncillary from "./mapperAxaInsuranceAncillary"
import mapperAxaUsInsurance from "./mapperAxaUsInsurance"

export default function (ancillaries: AncillariesInput): Ancillaries {
  return {
    usCoverMoreInsurance: mapperUsCoverMoreInsurance(ancillaries.cover_more_insurance),
    axa: mapperAxaInsuranceAncillary(ancillaries.axa_insurance),
    axaUsInsurance: mapperAxaUsInsurance(ancillaries.axa_us_insurance),
  }
}
